import React from "react";

type Props = {
  children: React.ReactNode;
};

type State = {
  hasError: boolean;
  message?: string;
};

export class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(error: unknown): State {
    const message = error instanceof Error ? error.message : String(error);
    return { hasError: true, message };
  }

  componentDidCatch(error: unknown, errorInfo: React.ErrorInfo) {
    // Keep a loud, actionable error in console for debugging white-screens
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary] Unhandled render error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-background text-foreground">
          <main className="mx-auto flex min-h-screen w-full max-w-3xl flex-col items-center justify-center px-6 py-16 text-center">
            <h1 className="text-2xl font-semibold">משהו השתבש</h1>
            <p className="mt-2 text-sm text-muted-foreground">
              זו שגיאת רינדור שמנעה מהאפליקציה להיטען. פתחו Console כדי לראות את הפרטים.
            </p>
            {this.state.message ? (
              <pre className="mt-6 w-full overflow-auto rounded-md border bg-muted p-4 text-left text-xs leading-relaxed">
                {this.state.message}
              </pre>
            ) : null}
          </main>
        </div>
      );
    }

    return this.props.children;
  }
}
